<template>
    <div id="question-zone">
        <div id="number-question">
            Question 1/3
        </div>
        <div id="question">
            <h2>Quels sont les facteurs à l'origine de la SEP ? </h2>
            <div class="questions-radios">
                <div class="question-radio">
                    <input :disabled="validationQ1" id="genetiques"  value="Uniquement des facteurs génétiques" type="radio" v-model="choiceQ1" name="test">
                    <label for="genetiques">Uniquement des facteurs génétiques</label>
                </div>
                <div class="question-radio">
                    <input :disabled="validationQ1" id="epigenetiques" value="Des facteurs épigénétiques" type="radio" v-model="choiceQ1" name="test">
                    <label for="epigenetiques">Des facteurs épigénétiques</label>
                </div>
                <div class="question-radio" id="good">
                    <input :disabled="validationQ1" id="genetique-et-environnementaux" value="Des facteurs génétique et environnementaux"
                           type="radio" v-model="choiceQ1" name="test">
                    <label for="genetique-et-environnementaux">Des facteurs génétique et environnementaux</label>
                </div>
                <div class="question-radio">
                    <input :disabled="validationQ1" id="environnementaux" type="radio" value="Uniquement des facteurs environnementaux"
                           v-model="choiceQ1" name="test">
                    <label for="environnementaux">Uniquement des facteurs environnementaux</label>
                </div>
            </div>
            <div id="result">
                <div>
                    <span id="message" v-show="validationQ1">
                        texte
                    </span>
                </div>
                <transition name="button-transition" leave-active-class="animated fadeOutDown" enter-active-class="animated fadeInUp" mode="out-in">
                    <button @click="emitNextQ" key="Valid" v-if="validationQ1">
                        Suivant →
                    </button>
                    <button :disabled="choiceQ1 === ''" @click="validationQ1M" key="NoValid" v-else>
                        Validez →
                    </button>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Question1',
        data() {
            return {
                choiceQ1: '',
                validationQ1 : false
            }
        },
        methods: {
            validationQ1M() {
                if (this.choiceQ1 === "Des facteurs génétique et environnementaux") {
                    $('input[name=test]:checked').parent().addClass('true')
                    $('#message').addClass('true').text("Ceci est la bonne réponse")
                } else {
                    $('input[name=test]:checked').parent().addClass('false')
                    $('#good').addClass('true')
                    $('#message').addClass('false').text("Ceci est une mauvaise réponse")
                }
                this.validationQ1 = true
            },
            emitNextQ(){
                this.$emit('next')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/default";
    .questions-radios {
        .question-radio {
            font-size: 1.75rem;
            position: relative;
            margin: 3% 0;
            max-width: 800px;
            padding: 10px;
            &.false{
                border-radius: 30px;
                background-color: $red-light-false;
                border: 2px solid $red-false;
                label {
                    &:before{
                        border: 2px solid $red-false;
                        background-color: $red-light-false;
                    }
                    &:after{
                        content: "✗";
                        position: absolute;
                        right: 30px;
                        opacity: 1;
                        color: $red-false;
                        top: 10%;
                        font-size: 2rem;
                    }
                }
                input[type="radio"]:checked + label:before {
                    border: 2px solid $red-false;
                    background-color: $red-false;
                    box-shadow: inset 0px 0px 0px 5px $red-light-false;
                }
            }
            &.true{
                border-radius: 30px;
                background-color: $green-light-true;
                border: 2px solid $green-true;
                label {
                    &:before{
                        border: 2px solid $green-true;
                        background-color: $green-light-true;
                    }
                    &:after{
                        content: "✓";
                        position: absolute;
                        right: 30px;
                        opacity: 1;
                        color: $green-true;
                        top: 10%;
                        font-size: 2rem;
                    }
                }
                input[type="radio"]:checked + label:before {
                    border: 2px solid $green-true;
                    background-color: $green-true;
                    box-shadow: inset 0px 0px 0px 5px $green-light-true;
                }
            }
            label {
                color: #333333;
                cursor: pointer;
                &:before {
                    content: "✓";
                    background-color: white;
                    border: 2px #d9d9d9 solid;
                    padding: 0 6px;
                    margin-right: 2%;
                    color: transparent;
                    -webkit-transition: 0.25s;
                    border-radius: 100%;
                    transition: 0.25s;
                    -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                }
                &:after{
                    content: "✓";
                    opacity: 0;
                }
            }
            input[type="radio"] {
                position: absolute;
                opacity: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
            input[type="radio"]:checked + label:before {
                border: 2px solid #d9d9d9;
                background-color: $blue;
                box-shadow: inset 0px 0px 0px 5px #fff;
            }
        }
    }

</style>
